import { inject, Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class LocalizedDateAdapter extends NativeDateAdapter {
  private transloco = inject(TranslocoService);

  constructor() {
    super('es');
    this.transloco.langChanges$.subscribe(() => {
      this.setLocale(this.transloco.getActiveLang());
    });
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const key = `material.datepicker.days.${style}`;
    const result = this.transloco.translate(key);
    if (Array.isArray(result) && result.length === 7) {
      return result;
    }
    return super.getDayOfWeekNames(style);
  }

  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    if (style === 'narrow') {
      return super.getMonthNames(style);
    }
    const key = `material.datepicker.months.${style}`;
    const result = this.transloco.translate(key);
    if (Array.isArray(result) && result.length === 12) {
      return result;
    }
    return super.getMonthNames(style);
  }

  override getDateNames(): string[] {
    const dateNames: string[] = [];
    for (let i = 1; i <= 31; i++) {
      dateNames.push(String(i));
    }
    return dateNames;
  }

  /**
   * Forzamos formato DD/MM/AAAA en todos los inputs de fecha de Material,
   * independientemente del idioma activo. Sin esto, NativeDateAdapter usa
   * `toLocaleDateString` y en `en` queda M/D/YYYY (ej. "4/1/2026").
   */
  override format(date: Date, _displayFormat: object): string {
    if (!this.isValid(date)) return '';
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = String(date.getFullYear());
    return `${dd}/${mm}/${yyyy}`;
  }
}
